/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Stack } from "@mui/material";

import Typography from "../../../../components/Typography";

interface TabHeaderProps {
  title: string;
  caption: string;
}

const TabHeader = ({ title, caption }: TabHeaderProps) => {
  return (
    <Stack direction="column">
      <Typography fontWeight="bold" variant="body2" color="primary500">
        {title}
      </Typography>
      <Typography variant="caption" color="grey900">
        {caption}
      </Typography>
    </Stack>
  );
};

export default TabHeader;
